import { fromStateNameToCode } from "../../helpers/stateHelpers";
import { normalizeAddressState } from "../form_fields/addressNormalizer";
import { normalizeDateToISO } from "../../date/DateUtils";

const service = "PTF";

// Fields that contain state values and need normalization
const STATE_FIELDS = new Set([
  "stateResidence",
]);

// Fields that contain date values and need normalization
const DATE_FIELDS = new Set([
  "dBirth",
]);

export const populateFromFiling = (filing, field, defaultValue = 0) => {
  const taxDetails = filing?.tax_situation?.details || {};
  const fieldData = taxDetails?.[service]?.situation?.[field];
  
  // If fieldData is an object with a value property
  if (fieldData && typeof fieldData === "object" && "value" in fieldData) {
    return { value: fieldData.value };
  }
  
  // No data found
  return { value: defaultValue };
};

export const populateSimpleDataFromFiling = (
  filing,
  field,
  defaultValue,
  schemaKey
) => {
  const taxDetails = filing?.tax_situation?.details || {};
  const dataPath = schemaKey === "Background" ? "background" : "situation";
  let value = taxDetails?.[service]?.[dataPath]?.[field] || defaultValue;

  // Normalize incomeStates
  if (field === "incomeStates" && value && typeof value === "object") {
    const normalized = {};
    Object.keys(value).forEach((year) => {
      const states = value[year];
      if (Array.isArray(states)) {
        normalized[year] = states
          .map((state) => fromStateNameToCode(state))
          .filter((code) => code !== null);
      } else if (typeof states === "string") {
        const code = fromStateNameToCode(states);
        normalized[year] = code ? [code] : [];
      } else {
        normalized[year] = states;
      }
    });
    value = normalized;
  }

  // Normalize state fields
  if (STATE_FIELDS.has(field) && value && typeof value === "string") {
    value = fromStateNameToCode(value);
  }

  // Normalize date fields
  if (DATE_FIELDS.has(field) && value && typeof value === "string") {
    value = normalizeDateToISO(value);
  }

  return value;
};

export const populateMultiAddressFromFiling = (filing, field, schemaKey) => {
  const taxDetails = filing?.tax_situation?.details || {};
  const dataPath = schemaKey === "Background" ? "background" : "situation";
  const addresses = taxDetails?.[service]?.[dataPath]?.[field] || [];

  if (Array.isArray(addresses)) {
    return addresses.map(normalizeAddressState);
  }

  return addresses;
};

export const populateSingleAddressFromFiling = (filing, field, schemaKey) => {
  const taxDetails = filing?.tax_situation?.details || {};
  const dataPath = schemaKey === "Background" ? "background" : "situation";
  let address = taxDetails?.[service]?.[dataPath]?.[field] || null;

  // Remove fromDate and toDate if they exist (single addresses don't have dates)
  if (address && typeof address === "object") {
    const { fromDate, toDate, ...addressWithoutDates } = address;
    return normalizeAddressState(addressWithoutDates);
  }

  return address;
};
